<template>
<div id="AssetSaleView">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="page-name">
                <span class="page-title" id="purchaseorderHeader"> Asset Sale</span>
                <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                <div class="btn-groups text-right">
                    <button type="submit" class="btn btn-secondary" v-on:click.prevent="backToList">
                        <i class="fp-back"> </i> Back
                    </button>
                    <button type="submit" v-if="posted == 'yes' && (inv_number == '' || inv_number == null)" class="btn btn-secondary" v-on:click.prevent="generateInvoice">
                        Post Invoice
                    </button>
                </div>
            </div>
            <div class="container-fluid">
                <div class="admin-page-content customer-view list-view">
                  <section class="internal-container">
                   <div id="tabs" class="containerTab mt-3">
                    <div class="tabs">
                      <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Asset Sale Details</a>
                      <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity Log</a>
                    </div>
                    <div class="content">
                      <div v-show="activetab === 1" class="tabcontent">
                    <div class="list-sections">
                        <div class="form-row section-divider" style="border-bottom:0px;">
                            <div class="col-md-6">
                                <div class="row form-group">
                                    <label class="col">#Unit :</label>
                                    <span class="col">{{unit_no}}</span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Unit Type :</label>
                                    <span class="col">{{truck_type}}</span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Assigned Facility :</label>
                                    <span class="col">{{assigned_facility}}</span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Year :</label>
                                    <span class="col">{{year}}</span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">#VIN :</label>
                                    <span class="col">{{vin}}</span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Make :</label>
                                    <span class="col">{{make}}</span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Model :</label>
                                    <span class="col">{{model}}</span>
                                </div>
                                <div class="row form-group" v-if="customer_id != ''">
                                    <label class="col">Customer :</label>
                                    <span class="col">{{customer_id}}</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="row form-group">
                                    <label class="col">Disposal Date :</label>
                                    <span class="col">{{disposal_date}}</span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Disposal Type :</label>
                                    <span class="col">{{sales_type}}</span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Owning Facility :</label>
                                    <span class="col" v-if="selling_facility.text">{{selling_facility.text}}</span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Misc. Charges:</label>
                                    <span class="col"> ${{amountFormat(miscellaneous_charge)}}</span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Selling Price:</label>
                                        <span class="col"> ${{amountFormat(sold_price)}}</span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Balance:</label>
                                        <span class="col"> ${{amountFormat(balance)}}</span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">DIST:</label>
                                    <span class="col">{{miles}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                      <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                          <asset-sale-activity-log-list :activityLogVal="activityLogsTabValue"></asset-sale-activity-log-list>
                      </div>
                    </div>
                  </div>
                <div id="workorder-detail work-order-view-top" class="admin-page-content credit-note-view" v-if="activetab === 1">
                    <section class="internal-container border-top-table-fl">
                    <h5>Charges</h5>
                        <template v-if="!chargesArr || chargesArr.length == 0 || chargesArr == undefined">
                            <div class="lineitem-main-section">
                            <h5>No Charges Added</h5>
                            </div>
                        </template>
                        <template v-else>
                            <div class="table-responsive-sm">
                                <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="chargesArr != undefined && chargesArr.length > 0">
                                    <thead>
                                        <tr class="table-primary">
                                            <th>Code</th>
                                            <th>Description</th>
                                            <th class="text-right">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in chargesArr" v-bind:key="index">
                                            <td v-if="item.description != null"> {{ item.description}} </td>
                                            <td v-else> - </td>
                                            <td v-if="item.description != null && item.description != ''"> {{ item.description}} </td>
                                            <td v-else> - </td>
                                            <td class="text-right"> ${{ amountFormat(item.amount)}} </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </section>
                </div>
                <div id="workorder-detail work-order-view-top" class="admin-page-content credit-note-view" v-if="activetab === 1 && canViewGL && glArr.length > 0">
                    <section class="internal-container border-top-table-fl mt-4">
                        <div class="journal-title">
                            <h5> General Ledger <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#demo'"></i> </h5>
                        </div>
                        <div :id="'demo'" class="accordian-body collapse show">
                            <div class="table-reponsive">
                                <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th>Account</th>
                                            <th class="text-right">Debit</th>
                                            <th class="text-right">Credit</th>
                                            <th class="text-right">Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="glArr != undefined && glArr.length > 0">
                                        <template v-for="(journalItem , journalKey) in glArr">
                                            <tr :key="'journal'+journalKey">
                                                <template v-if="journalItem.account_description == 'Total'">
                                                    <td class="text-right">{{journalItem.account_description}}</td>
                                                </template>
                                                <template v-else>
                                                    <td>{{journalItem.account_description}}</td>
                                                </template>
                                                <td class="text-right">{{journalItem.debit}}</td>
                                                <td class="text-right">{{journalItem.credit}}</td>
                                                <td class="text-right">{{journalItem.journal_amount}}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="4"><h5>No GL Found</h5></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </section>
                </div>
                </section>
              </div>
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
    </div>
</div>
</template>

<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import moment from 'moment';
import ActivityLogListView from '@/components/ActivityLogList.vue';
Vue.component("asset-sale-activity-log-list", ActivityLogListView);


export default {
    name: "AssetSaleView",
    metaInfo() {
        return {
            title: "Asset Sale View | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins: [commonMixins, contractMixins],
    data: () => ({
        isEdit: false,
        permissions: [],
        cantAccessPage: "",
        vehicle_id: "",
        loading: false,
        vin:'',
        sold_price:'',
        selling_facility:'',
        sales_location:'',
        reconditioning_cost:'',
        net_book_value:'',
        pricing_value:'',
        list_price:'',
        selling_facility_error_msg:'',
        loadOnce:false,
        sales_person_id:'',
        disposal_type_error_msg:'',
        telephone:'',
        sales_person_error_msg:'',
        miles:'',
        balance:0.00,
        tax:0.00,
        payments:0.00,
        miscellaneous_charge:0.00,
        disposal_date:'',
        model:'',
        make:'',
        year:'',
        customer_id:null,
        wo_no:'',
        truck_type:'',
        assigned_facility:'',
        unit_no:'',
        sales_type:'',
        chargesArr:[],
        pageKey:"_vehicle_sale_view_",
        glArr:[],
        canViewGL:false,
        sale_batch:'',
        posted:'',
        inv_number:'',
        activetab: 1,
        activityLogsTabValue: "dontLoadList",
        activityLoaded:false,
    }),

    watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'view_asset_sales') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'view_general_ledger') {
                        self.canViewGL = true;
                    }
                }
            }

        },
        vehicle_id: function(val) {

            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");

            if(val != null && val != '' && val.value){

                $.ajax({
                    url: process.env.ROOT_API + "/asset/"+val.value,
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType:"json",

                    success: function (data) {
                        //if data is edit than dont make model id blank
                        if (data.status == "success") {
                            self.vin = data.content.vin;
                            self.unit_no = data.content.unit_no;
                            self.truck_type = data.content.vtCode+' | '+data.content.vtName;
                            if (data.content.plCode != null && data.content.plCode != ''){
                              self.assigned_facility = data.content.plCode+' | '+data.content.plName;
                            }
                            self.net_book_value = data.content.net_book_value;
                            self.make = data.content.vmCode+' | '+data.content.vmName;
                            if (data.content.vmodelsCode != null && data.content.vmodelsCode != ''){

                                self.model = data.content.vmodelsCode+' | '+data.content.vmodelsName;

                            }
                            if (data.content.year != null){

                                self.year = data.content.year;

                            }
                            self.readingDetails();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'asset-data')
                    }
                });
            }

        },

    },
    created: function () {

    },
    mounted: function () {
        var self = this;
        // self.statusValue = 1;
        var path = window.location.pathname;
        var segments = path.split("/");

        var userObj = JSON.parse(localStorage.getItem("user_obj"));
        if (userObj != null) {
            // var userJson = JSON.parse(userObj);
            // if (userObj.roles.length > 0) {
            //     self.role = userObj.roles[0].name;

            // }
            if ( segments[3]){
                self.loadAssetSale();
            }else{

            }

            // self.getCharges();

        }

        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");

    },
    methods: {

        readingDetails:function(){
            var self = this;

            $.ajax({
                url: process.env.ROOT_API + "/reading-detail-by-vehicle",
                type: "GET",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    vehicle_id:self.vehicle_id.value
                },
                success: function (data) {
                    self.loading = false;
                    console.log(data);
                    self.readingArr = [];

                    if (data.status == "success") {
                        if (data.content && data.content.length){
                           self.readingArr = data.content;
                           var reading = self.readingArr;

                           reading.forEach(element => {
                               if (element.secCode == 'DIST'){
                                   self.miles = element.reading;
                               }
                           });
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'asset-requisition-load')

                }
            });
        },


        loadAssetSale() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/asset-sale/" + segments[3]+"?flag=view",
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);

                        if (data.status == "success") {
                            var dataSet = data.content.vehicle;
                            self.vehicle_id = {text:dataSet.unit_no+' | '+dataSet.vtCode+' | '+dataSet.vtName+' | '+dataSet.lName,value:dataSet.vehicle_id};
                            self.disposal_date = dataSet.date_sold;
                            self.sold_price = dataSet.pricing_value;
                            self.next_inspection_date = dataSet.next_inspection_date;
                            self.selling_facility = {text:dataSet.lCode+' | '+dataSet.lName,value:dataSet.selling_facility};
                            setTimeout(function(){

                                self.sales_location = {text:dataSet.saleLocCode+' | '+dataSet.saleLocName,value:dataSet.sales_location};

                            },500);
                            self.telephone = dataSet.telephone;
                            self.sales_type = self.titleCase(dataSet.sales_type);
                            if (dataSet.repId){

                                self.sales_person_id = {text:self.titleCase(dataSet.sales_person_id),value:dataSet.repId};

                            }
                            self.balance = dataSet.list_price
                            self.chargesArr = dataSet.charges_item;
                            var total = 0;
                            for(var i = 0;i < self.chargesArr.length;i++){
                                if (self.chargesArr[i].amount != ''){

                                    total += parseFloat(self.chargesArr[i].amount);

                                }
                            }
                            self.miscellaneous_charge = total;
                            self.miles = dataSet.miles;
                            if (dataSet.customer_id != null) {
                                self.customer_id = dataSet.cust_code + " | " + dataSet.cust_name;
                            }
                            if (dataSet.gl != undefined && dataSet.gl != null) {
                                self.glArr = dataSet.gl;
                            }
                            self.sale_batch = dataSet.batch;
                            self.inv_number = dataSet.inv_number;
                            self.posted = dataSet.posted;
                            // self.disposalDetailsArr = dataSet.disposal_details;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'asset-sale-load')

                    }
                });
            },

        generateInvoice:function(){
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            $.ajax({
                url: process.env.ROOT_API + "/generate-sale-invoice",
                type: "POST",
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    sale_id:segments[3],
                    batch:self.sale_batch
                },
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                       self.$router.push("/invoice/asset-sale/view/"+data.content+'?saleId='+segments[3]+'&from=asset-sale-view');
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'asset-sale-invoice')

                }
            });

        },
        titleCase(str) {
            if (str == null) {
                return;
            } else {
                var value = str.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },

        backToList: function(){
            var self = this;
            if(self.$route.query.from && self.$route.query.from != undefined && self.$route.query.from == 'gl'){
                self.$router.push('/report/general-ledger');
            }else{
                self.$router.push('/asset-sale/list');
            }
        },

        amountFormatForPage(amount) {

            return amount.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });
        },
        activityLogs(){

          var self = this;
          var path = window.location.pathname;
          var segments = path.split("/");

          self.$root.$emit('activity_log_opted','asset sales',segments[3]);
          self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
          self.activetab = 2;
        },
    }
};
</script>




// WEBPACK FOOTER //
// src/components/asset/AssetSaleView.vue